import React from "react";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import App from "./App.jsx";
import { initialize } from "./src/state/uiActions.js";
import "./styles.css";
const root = createRoot(document.getElementById("app"));
flushSync(() => root.render(<App />));
initialize();
